import { checkNull2String, checkNull2Int } from "./ItemTools"

export const WageType0 = "0"
export const WageType1 = "1"
export const WageType2 = "2"
export const WageType3 = "3"

export const WageType_Arr = [
    { val: WageType1, name: "時薪" },
    { val: WageType2, name: "月薪" },
    { val: WageType3, name: "代招" }
]

export const JobDemand_Arr = [
    { val: "1", name: "大缺" },
    { val: "2", name: "少量缺，有人再約時間面試" },
    { val: "3", name: "少量缺，有人送書審" },
    { val: "4", name: "下週開缺" },
    { val: "5", name: "下個月初開缺" },
    { val: "6", name: "下個月中開缺" },
    { val: "7", name: "下個月底開缺" },
    { val: "8", name: "額滿" },
]

export const BusinessTaxType_Contains = 1
export const BusinessTaxType_Addition = 2

export const BusinessTaxType_Contains_String = "內含"
export const BusinessTaxType_Addition_String = "外加"

export const BusinessTaxType_Arr = [
    { val: BusinessTaxType_Contains, name: BusinessTaxType_Contains_String },
    { val: BusinessTaxType_Addition, name: BusinessTaxType_Addition_String },
]

export function getBusinessTaxTypeString(val) {
    switch (parseInt(val)) {
        case BusinessTaxType_Contains:
            return BusinessTaxType_Contains_String
        case BusinessTaxType_Addition:
            return BusinessTaxType_Addition_String
        default:
            return ""
    }
}

export const InsuranceBurdenType_Company = 1
export const InsuranceBurdenType_Customer = 2

export const InsuranceBurdenType_Company_String = "公司負擔"
export const InsuranceBurdenType_Customer_String = "廠商負擔"

export const InsuranceBurdenType_Arr = [
    { val: InsuranceBurdenType_Company, name: InsuranceBurdenType_Company_String },
    { val: InsuranceBurdenType_Customer, name: InsuranceBurdenType_Customer_String },
]

export function getInsuranceBurdenTypeString(val) {
    switch (parseInt(val)) {
        case InsuranceBurdenType_Company:
            return InsuranceBurdenType_Company_String
        case InsuranceBurdenType_Customer:
            return InsuranceBurdenType_Customer_String
        default:
            return ""
    }
}

export const MarginCalculationType_Fixed = 1
export const MarginCalculationType_BaseSalaryRatio = 2
export const MarginCalculationType_RealPayRatio = 3

export const MarginCalculationType_Fixed_String = "固定金額"
export const MarginCalculationType_BaseSalaryRatio_String = "底薪比率"
export const MarginCalculationType_RealPayRatio_String = "實薪比率"

export const MarginCalculationType_Arr = [
    { val: MarginCalculationType_Fixed, name: MarginCalculationType_Fixed_String },
    { val: MarginCalculationType_BaseSalaryRatio, name: MarginCalculationType_BaseSalaryRatio_String },
    { val: MarginCalculationType_RealPayRatio, name: MarginCalculationType_RealPayRatio_String },
]

export function getMarginCalculationTypeString(val) {
    switch (parseInt(val)) {
        case MarginCalculationType_Fixed:
            return MarginCalculationType_Fixed_String
        case MarginCalculationType_BaseSalaryRatio:
            return MarginCalculationType_BaseSalaryRatio_String
        case MarginCalculationType_RealPayRatio:
            return MarginCalculationType_RealPayRatio_String
        default:
            return ""
    }
}

export const LaborInsuranceType_FullTime = 1
export const LaborInsuranceType_PartTime = 2
export const LaborInsuranceType_Disability = 3


export const LaborInsuranceType_Arr = [
    { val: LaborInsuranceType_FullTime, name: "全職型" },
    { val: LaborInsuranceType_PartTime, name: "兼職型" },
    { val: LaborInsuranceType_Disability, name: "身心障礙型" },
]

export const GroupInsuranceType_NoNeed = 1
export const GroupInsuranceType_Need = 2
export const GroupInsuranceType_NoNeed_String = "不需加保"
export const GroupInsuranceType_Need_String = "加保在職期間"

export const GroupInsuranceType_Arr = [
    { val: GroupInsuranceType_NoNeed, name: GroupInsuranceType_NoNeed_String },
    // { val: 2, name: "加保報到當日" },
    { val: GroupInsuranceType_Need, name: GroupInsuranceType_Need_String },
]

export function getGroupInsuranceTypeString(val) {
    switch (parseInt(val)) {
        case GroupInsuranceType_NoNeed:
            return GroupInsuranceType_NoNeed_String
        case GroupInsuranceType_Need:
            return GroupInsuranceType_Need_String
        default:
            return ""
    }
}

export const InsuranceSOPType_3In1 = 1
export const InsuranceSOPType_2In1 = 2
export const InsuranceSOPType_3In1_String = "三合一"
export const InsuranceSOPType_2In1_String = "二合一"

export const InsuranceSOPType_Arr = [
    { val: InsuranceSOPType_3In1, name: "三合一" },
    { val: InsuranceSOPType_2In1, name: "二合一" },
]

export function getInsuranceSOPTypeString(val) {
    switch (parseInt(val)) {
        case InsuranceSOPType_3In1:
            return InsuranceSOPType_3In1_String
        case InsuranceSOPType_2In1:
            return InsuranceSOPType_2In1_String
        default:
            return ""
    }
}

export const DateOfInsuranceOnboard = 1
export const DateOfInsuranceReserve = 2
export const DateOfInsuranceOnboard_String = "上工日"
export const DateOfInsuranceReserve_String = "預定上工日"


export const DateOfInsurance_Arr = [
    { val: DateOfInsuranceOnboard, name: "上工日" },
    { val: DateOfInsuranceReserve, name: "預定上工日" },
]

export function getDateOfInsuranceString(val) {
    switch (parseInt(val)) {
        case DateOfInsuranceOnboard:
            return DateOfInsuranceOnboard_String
        case DateOfInsuranceReserve:
            return DateOfInsuranceReserve_String
        default:
            return ""
    }
}

export class ReqCustomerPositionList {
    constructor({ customerContractId, wageType }) {
        this.customerContractId = customerContractId
        this.wageType = wageType
    }

    fromJson(jsonData) {
        this.customerContractId = jsonData.customerContractId
        this.wageType = jsonData.wageType
        // this.start = jsonData.start === undefined? 0 : jsonData.start
        // this.limit = jsonData.limit === undefined? 1000 : jsonData.limit
    }
}

export class ReqCustomerPositionDetail {
    constructor({ customerContractId, customerPositionId }) {
        this.customerContractId = customerContractId
        this.customerPositionId = customerPositionId
    }
    fromJson(jsonData) {
        this.customerContractId = jsonData.customerContractId
        this.customerPositionId = jsonData.customerPositionId
    }
}

export class RespCustomerPosition {
    constructor({ customerContractId, customerPositionId, info, isDisable = 0, creatAccountId, creatAt }) {
        this.customerContractId = customerContractId
        this.customerPositionId = customerPositionId
        this.info = info
        this.isDisable = isDisable
        if (creatAccountId !== undefined)
            this.creatAccountId = creatAccountId
        if (creatAt !== undefined)
            this.creatAt = creatAt
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)
        this.customerContractId = jsonData.customerContractId
        this.customerPositionId = jsonData.customerPositionId
        this.info = new RespCustomerPositionInfo({})
        this.info.fromJson(jsonData.info)
        this.isDisable = jsonData.isDisable
        this.creatAccountId = jsonData.creatAccountId
        this.creatAt = jsonData.creatAt
    }
}

export class RespCustomerPositionDetail {
    constructor({ customerContractId, customerPositionId, companyName, signAt, isPublic = 0, info, isDisable = 0, creatAccountId, creatAt }) {
        this.customerContractId = customerContractId
        this.customerPositionId = customerPositionId
        this.companyName = companyName
        this.signAt = signAt
        this.isPublic = isPublic
        this.info = info
        this.isDisable = isDisable
        if (creatAccountId !== undefined)
            this.creatAccountId = creatAccountId
        if (creatAt !== undefined)
            this.creatAt = creatAt
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)
        this.customerContractId = jsonData.customerContractId
        this.customerPositionId = jsonData.customerPositionId
        this.companyName = jsonData.companyName
        this.signAt = jsonData.signAt
        this.isPublic = jsonData.isPublic
        this.info = new RespCustomerPositionInfo({})
        this.info.fromJson(jsonData.info)
        this.isDisable = jsonData.isDisable
        this.creatAccountId = jsonData.creatAccountId
        this.creatAt = jsonData.creatAt
    }
}


export class RespCustomerPositionInfo {
    constructor({
        job,                //職稱
        shift,              //班別名稱
        workPlace,          //工作地點
        workAddress,        //工作地址
        jobRequirement,     //招募條件
        jobDemand,          //職缺需求量
        wageType,           //服務費計算方式
        /**
         * 1    時薪
         * 2    月薪-定額
         * 3    月薪-實領固定比率
         * 4    月薪-底薪固定比率
         * 5    代招
         */
        wageInfo,               //服務費計算內容
        insuranceInfo       //保險
    }) {
        this.job = job
        this.shift = shift
        this.workPlace = workPlace
        this.workAddress = workAddress
        this.jobRequirement = jobRequirement
        this.jobDemand = jobDemand
        this.wageType = wageType
        this.wageInfo = wageInfo
        this.insuranceInfo = insuranceInfo
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        console.log(jsonData)
        this.job = jsonData.job || ""
        this.shift = jsonData.shift || ""
        this.workPlace = jsonData.workPlace || ""
        this.workAddress = jsonData.workAddress || ""
        this.jobRequirement = jsonData.jobRequirement || ""
        this.jobDemand = jsonData.jobDemand || ""
        this.wageType = jsonData.wageType || ""
        if(jsonData.wageType === undefined || jsonData.wageInfo === undefined){
            this.wageInfo = ""
        }else{
            switch(this.wageType){
                case WageType1:
                    this.wageInfo = new RespCustomerPositionInfo_WageInfo_WageType1({})
                    break
                case WageType2:
                    this.wageInfo = new RespCustomerPositionInfo_WageInfo_WageType2({})
                    break
                case WageType3:
                    this.wageInfo = new RespCustomerPositionInfo_WageInfo_WageType3({})
                    break
                default:
                    break;
            }
            try {
                this.wageInfo.fromJson(jsonData.wageInfo)
            } catch (error) {
                
            }
        }
        // this.wageInfo = jsonData.wageInfo || ""
        if(jsonData.insuranceInfo === undefined){
            this.insuranceInfo = ""
        }else{
            this.insuranceInfo = new RespCustomerPositionInfo_Insurance({})
            this.insuranceInfo.fromJson(jsonData.insuranceInfo)
        }
        // this.insuranceInfo = jsonData.insuranceInfo || ""
    }
}

export class RespCustomerPositionInfo_WageInfo_WageType1 {
    /**
     * 事業單位資訊
     * @constructor
     * @param {int} InvoiceHourlyWage1 請款金額 正常班時薪金額-前8小時
     * @param {int} InvoiceHourlyWage2 請款金額 加班時薪金額-加班前2小-1.34倍
     * @param {int} InvoiceHourlyWage3 請款金額 超時加班時薪金額-加班2小後-1.67倍
     * @param {int} InvoiceHourlyWage4 請款金額 假日加班時薪金額-2倍
     * @param {String} BusinessTaxType 營業稅
     * @param {String} InsuranceBurdenType 勞健保保險費用
     * @param {int} PayHourlyWage1 給付金額 正常班時薪金額-前8小時
     * @param {int} PayHourlyWage2 給付金額 加班時薪金額-加班前2小-1.34倍
     * @param {int} PayHourlyWage3 給付金額 超時加班時薪金額-加班2小後-1.67倍
     * @param {int} PayHourlyWage4 給付金額 假日加班時薪金額-2倍
     * @param {int} ExtraPayeHourlyWage 家庭照顧金
     * @param {int} AddInsuranceBurdenType 健保補充保費
     * @param {Array} SalaryAddItem 薪資加項
     * @param {Array} SalarySubtractItem 薪資減項
     */
    constructor({ InvoiceHourlyWage1 = 0, InvoiceHourlyWage2 = 0, InvoiceHourlyWage3 = 0, InvoiceHourlyWage4 = 0, BusinessTaxType = "",
        InsuranceBurdenType = InsuranceBurdenType_Company, PayHourlyWage1 = 0, PayHourlyWage2 = 0, PayHourlyWage3 = 0, PayHourlyWage4 = 0,
        ExtraPayeHourlyWage = 0, AddInsuranceBurdenType = InsuranceBurdenType_Company, SalaryAddItem = [], SalarySubtractItem = [] }) {
        this.InvoiceHourlyWage1 = InvoiceHourlyWage1
        this.InvoiceHourlyWage2 = InvoiceHourlyWage2
        this.InvoiceHourlyWage3 = InvoiceHourlyWage3
        this.InvoiceHourlyWage4 = InvoiceHourlyWage4
        this.BusinessTaxType = BusinessTaxType
        this.InsuranceBurdenType = InsuranceBurdenType
        this.PayHourlyWage1 = PayHourlyWage1
        this.PayHourlyWage2 = PayHourlyWage2
        this.PayHourlyWage3 = PayHourlyWage3
        this.PayHourlyWage4 = PayHourlyWage4
        this.ExtraPayeHourlyWage = ExtraPayeHourlyWage
        this.AddInsuranceBurdenType = AddInsuranceBurdenType
        this.SalaryAddItem = SalaryAddItem
        this.SalarySubtractItem = SalarySubtractItem
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        //console.log(jsonData)
        this.InvoiceHourlyWage1 = jsonData.InvoiceHourlyWage1 || 0
        this.InvoiceHourlyWage2 = jsonData.InvoiceHourlyWage2 || 0
        this.InvoiceHourlyWage3 = jsonData.InvoiceHourlyWage3 || 0
        this.InvoiceHourlyWage4 = jsonData.InvoiceHourlyWage4 || 0
        this.BusinessTaxType = jsonData.BusinessTaxType || ""
        this.InsuranceBurdenType = jsonData.InsuranceBurdenType || InsuranceBurdenType_Company
        this.PayHourlyWage1 = jsonData.PayHourlyWage1 || 0
        this.PayHourlyWage2 = jsonData.PayHourlyWage2 || 0
        this.PayHourlyWage3 = jsonData.PayHourlyWage3 || 0
        this.PayHourlyWage4 = jsonData.PayHourlyWage4 || 0
        this.ExtraPayeHourlyWage = jsonData.ExtraPayeHourlyWage || 0
        this.AddInsuranceBurdenType = jsonData.InsuranceBurdenType || InsuranceBurdenType_Company
        this.SalaryAddItem = jsonData.SalaryAddItem || []
        this.SalarySubtractItem = jsonData.SalarySubtractItem || []
    }
}

export class RespCustomerPositionInfo_WageInfo_WageType2 {
    /**
     * @constructor
     * @param {int} MonthlySalary 底薪金額 
     * @param {String} InsuranceBurdenType 勞健保費用 
     * @param {String} MarginCalculationType 服務費計算方式 
     * @param {int} MonthlySalaryAmount 金額/比率% 
     * @param {String} BusinessTaxType 營業稅
     * @param {Array} SalaryAddItem 薪資加項
     * @param {Array} SalarySubtractItem 薪資減項
     */
    constructor({ MonthlySalary = 0, InsuranceBurdenType = InsuranceBurdenType_Customer, MarginCalculationType = "", MonthlySalaryAmount = 0, BusinessTaxType = "", SalaryAddItem = [], SalarySubtractItem = [] }) {
        this.MonthlySalary = MonthlySalary
        this.InsuranceBurdenType = InsuranceBurdenType
        this.MarginCalculationType = MarginCalculationType
        this.MonthlySalaryAmount = MonthlySalaryAmount
        this.BusinessTaxType = BusinessTaxType
        this.SalaryAddItem = SalaryAddItem
        this.SalarySubtractItem = SalarySubtractItem
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        // console.log(jsonData)
        this.MonthlySalary = jsonData.MonthlySalary || 0
        this.InsuranceBurdenType = jsonData.InsuranceBurdenType || InsuranceBurdenType_Customer
        this.MarginCalculationType = jsonData.MarginCalculationType || ""
        this.MonthlySalaryAmount = jsonData.MonthlySalaryAmount || 0
        this.BusinessTaxType = jsonData.BusinessTaxType || ""
        this.SalaryAddItem = jsonData.SalaryAddItem || []
        this.SalarySubtractItem = jsonData.SalarySubtractItem || []
    }
}

// export class RespCustomerPositionInfo_WageInfo_WageType3 {
//     /**
//      * @constructor
//      * @param {int} Salary2 實領薪水比率(%)
//      */
//     constructor({ Salary2 = 0 }) {
//         this.Salary2 = Salary2
//     }

//     fromJson(jsonData) {
//         if (typeof jsonData === "string")
//             jsonData = JSON.parse(jsonData)

//         //console.log(jsonData)
//         this.Salary2 = checkNull2Int(jsonData.Salary2)
//     }
// }

// export class RespCustomerPositionInfo_WageInfo_WageType4 {
//     /**
//      * @constructor
//      * @param {int} Salary3 底薪比率(%)
//      */
//     constructor({ Salary3 = 0 }) {
//         this.Salary3 = Salary3
//     }

//     fromJson(jsonData) {
//         if (typeof jsonData === "string")
//             jsonData = JSON.parse(jsonData)

//         //console.log(jsonData)
//         this.Salary3 = checkNull2Int(jsonData.Salary3)
//     }
// }

export class RespCustomerPositionInfo_WageInfo_WageType3 {
    /**
     * @constructor
     * @param {int} JobCommission 每期代招金額
     * @param {int} JobCommissionTerms 期數-（月）
     */
    constructor({ JobCommission = 0, JobCommissionTerms = 0 }) {
        this.JobCommission = JobCommission
        this.JobCommissionTerms = JobCommissionTerms
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        //console.log(jsonData)
        this.JobCommission = checkNull2Int(jsonData.JobCommission)
        this.JobCommissionTerms = checkNull2Int(jsonData.JobCommissionTerms)
    }
}

export class RespCustomerPositionInfo_Insurance {
    /**
     * @constructor
     * 保險
     */
    constructor({
        insuranceSOPTpye = "",       //保險作業方式
        dateOfInsurance = "",        //勞健保應加保日期
        laborInsuranceType = "",     //勞保類別
        laborInsuranceLevel = "",    //勞保投保級距
        laborInsuranceAmount,       //勞保投保級距金額
        healthInsuranceLevel = "",    //健保投保級距
        healthInsuranceAmount,       //健保投保級距金額
        insuredUnitGUI = "",         //勞健保投保公司統編
        groupInsuranceType = "",     //團保方式
        groupInsuranceBurdenType = "",  // 團保費用
        dateOfGroupInsurance = "",   //團保應加保日期
        groupInsuranceGUI = "",      //團保保險公司統編
        groupInsurancePremium = 0   //每人每日保費金額
    }) {
        this.insuranceSOPTpye = insuranceSOPTpye
        this.dateOfInsurance = dateOfInsurance
        this.insuredUnitGUI = insuredUnitGUI
        this.laborInsuranceType = laborInsuranceType
        this.laborInsuranceLevel = laborInsuranceLevel
        this.laborInsuranceAmount = laborInsuranceAmount
        this.healthInsuranceLevel = healthInsuranceLevel
        this.healthInsuranceAmount = healthInsuranceAmount
        this.groupInsuranceType = groupInsuranceType
        this.groupInsuranceBurdenType = groupInsuranceBurdenType
        this.dateOfGroupInsurance = dateOfGroupInsurance
        this.groupInsuranceGUI = groupInsuranceGUI
        this.groupInsurancePremium = groupInsurancePremium
    }

    fromJson(jsonData) {
        // console.log(typeof jsonData)
        try {
            if (typeof jsonData === "string")
                jsonData = JSON.parse(jsonData)
        } catch (error) {
            // console.log(error)
        }

        //console.log(jsonData)
        this.insuranceSOPTpye = jsonData.insuranceSOPTpye || ""
        this.dateOfInsurance = jsonData.dateOfInsurance || ""
        this.laborInsuranceType = jsonData.laborInsuranceType || ""
        this.laborInsuranceLevel = jsonData.laborInsuranceLevel || ""
        this.laborInsuranceAmount = jsonData.laborInsuranceAmount
        this.healthInsuranceLevel = jsonData.healthInsuranceLevel || ""
        this.healthInsuranceAmount = jsonData.healthInsuranceAmount 
        this.insuredUnitGUI = jsonData.insuredUnitGUI || ""
        this.groupInsuranceType = jsonData.groupInsuranceType || ""
        this.groupInsuranceBurdenType = jsonData.groupInsuranceBurdenType || ""
        this.dateOfGroupInsurance = jsonData.dateOfGroupInsurance || ""
        this.groupInsuranceGUI = jsonData.groupInsuranceGUI || ""
        this.groupInsurancePremium = jsonData.groupInsurancePremium || 0
    }

    setLaborInsuranceAmount(amount){
        this.laborInsuranceAmount = amount
    }

    setHealthInsuranceAmount(amount){
        this.healthInsuranceAmount = amount
    }
}
